import { render, staticRenderFns } from "./DateTimeLabel.vue?vue&type=template&id=22b8d5ee&scoped=true&"
import script from "./DateTimeLabel.vue?vue&type=script&lang=js&"
export * from "./DateTimeLabel.vue?vue&type=script&lang=js&"
import style0 from "./DateTimeLabel.vue?vue&type=style&index=0&id=22b8d5ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8d5ee",
  null
  
)

export default component.exports